
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared-list/[id]",
      function () {
        return require("private-next-pages/shared-list/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared-list/[id]"])
      });
    }
  